import routerOptions0 from "/home/runner/work/cabral.ro/cabral.ro/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/runner/work/cabral.ro/cabral.ro/app/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}